import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

interface IProps {
    is_Create?: boolean;
    is_Delete?: boolean;
    is_Update?: boolean;
    is_Export?: boolean;
    is_View?: boolean;
    is_Consultant?: boolean;
}

export const ShowPurchaseOrder = (permissions: IProps) => {
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    return (
        <>
            <Table permissions={permissions} toast={toast} reload={reload} setReload={setReload} isConsultant={permissions?.is_Consultant || false}></Table>
            <Toast ref={toast} />
        </>
    );
}
